<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="['/organizations']" [queryParams]="{search: searchTerm}"><span translate>Organizations</span></a></li>
    <li class="breadcrumb-item active" aria-current="page">
      <span translate>Configuration</span>:&nbsp;
      <span [innerText]="organizationName"></span>
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <div class="card nav-vertical">
      <div class="card-header"><i class="fa-solid fa-bars"></i><span translate>Configuration</span></div>
      <ul ngbNav orientation="vertical" [(activeId)]="show" (navChange)="onNavChange($event)">
        <li ngbNavItem="machines">
          <a ngbNavLink translate>Machines</a>
        </li>
        <li ngbNavItem="users">
          <a ngbNavLink translate>Users</a>
        </li>
        <li ngbNavItem="contacts">
          <a ngbNavLink translate>Support contacts</a>
        </li>
        <li ngbNavItem="constants">
          <a ngbNavLink translate>Organization constants</a>
        </li>
        <li ngbNavItem="settings">
          <a ngbNavLink translate>Settings</a>
        </li>

        @if (isWhiteLabelingEnabled) {
          <li ngbNavItem="branding">
            <a ngbNavLink translate>Design</a>
          </li>
        }

        @if (isWhiteLabelingEnabled) {
          <li ngbNavItem="mail-templates">
            <a ngbNavLink translate>Mail Templates</a>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="col-12 col-lg">
    <div class="tab-container">

      @if (show === ConfigurationTabs.MACHINES) {
        <scitis-admin-organization-machines
          [organizationName]="organizationName"
          [machines]="organizationMachines ?? []"
          >
        </scitis-admin-organization-machines>
      }

      @if (show === ConfigurationTabs.USERS) {
        <scitis-admin-organization-users
          [organizationName]="organizationName"
          [users]="organizationUsers ?? []"
          >
        </scitis-admin-organization-users>
      }

      @if (show === ConfigurationTabs.CONTACTS) {
        <scitis-admin-organization-support-contacts
          [organizationId]="organizationId"
          [organizationName]="organizationName"
          [contacts]="organizationSupportContacts ?? []"
          [isSuperAdminRole]="isSuperAdminRole"
          [isAdminRole]="isAdminRole"
          >
        </scitis-admin-organization-support-contacts>
      }

      @if (show === ConfigurationTabs.CONSTANTS) {
        <scitis-admin-organization-constant
          [organizationId]="organizationId"
          [organizationName]="organizationName"
          [constants]="organizationConstants ?? []"
          [portalSettings]="portalSettings ?? []"
          [isSuperAdminRole]="isSuperAdminRole"
          [isAdminRole]="isAdminRole"
          >
        </scitis-admin-organization-constant>
      }

      @if (show === ConfigurationTabs.SETTINGS) {
        <scitis-admin-organization-settings
          [organizationId]="organizationId"
          [organizationName]="organizationName"
          [isSuperAdminRole]="isSuperAdminRole"
          [isAdminRole]="isAdminRole">
        </scitis-admin-organization-settings>
      }

      @if (show === ConfigurationTabs.BRANDING) {
        <scitis-admin-organization-branding
          [organizationId]="organizationId"
          [organizationName]="organizationName"
          [isSuperAdminRole]="isSuperAdminRole"
          [isAdminRole]="isAdminRole"
          [branding]="organizationBranding"
          [parentBranding]="parentOrganizationBranding"
          [brandingIsLoading]="brandingIsNotLoaded"
          >
        </scitis-admin-organization-branding>
      }

      @if (show === ConfigurationTabs.MAIL) {
        <scitis-admin-organization-mail-settings
          [organizationId]="organizationId"
          [organizationName]="organizationName"
          [isSuperAdminRole]="isSuperAdminRole"
          [isAdminRole]="isAdminRole"
          [settings]="organizationMailSettings"
          >
        </scitis-admin-organization-mail-settings>
      }

    </div>
  </div>
</div>
